import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "motion/react";
import { transitionSoft, viewportOnce } from "../animations";

const MD_MIN_WIDTH = "(min-width: 768px)";

function useMdUp() {
  const [isMdUp, setIsMdUp] = React.useState(false);

  React.useEffect(() => {
    const mq = window.matchMedia(MD_MIN_WIDTH);
    const update = () => setIsMdUp(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMdUp;
}

function StoreBadge({ children }) {
  return (
    <motion.li whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
      {children}
    </motion.li>
  );
}

function IcbMobile() {
  const { t } = useTranslation();
  const isMdUp = useMdUp();

  return (
    <section className="relative mt-[109px] w-full overflow-hidden bg-gradient-to-b from-[#f7f7f7] via-[#f5f5f5] to-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(900px 520px at 18% 25%, rgba(218,0,17,0.08) 0%, rgba(218,0,17,0) 60%), radial-gradient(900px 520px at 88% 30%, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 55%)",
        }}
        aria-hidden
      />
      <div className="relative m-auto flex flex-col place-items-center px-4 md:flex-row lg:max-w-[1024px] xl:max-w-[1280px]">
        <motion.div
          className="md:py-[30px]"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={viewportOnce}
          transition={{ ...transitionSoft, delay: 0.06 }}
        >
          <h4 className="pt-[20px] text-[20px] font-medium uppercase text-[#da0011] md:pt-[0] md:text-[26px] lg:text-[30px]">
            {t("icbMobile.title")}
          </h4>
          <p className="my-[10px] text-justify text-[21px] font-normal leading-[25px] text-[#111827]/90 md:my-[20px] lg:my-[24px] xl:my-[28px]">
            {t("icbMobile.body")}
          </p>

          <ul className="flex">
            <StoreBadge>
              <a href="https://play.google.com/store/apps/details?id=tj.fmfb.mobile&hl=ru&gl=US">
                <img src="./img/googlePlay2.svg" alt="" />
              </a>
            </StoreBadge>
            <StoreBadge>
              <a
                href="https://itunes.apple.com/app/id1641458468"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="./img/appStore.svg" alt="" />
              </a>
            </StoreBadge>
            <StoreBadge>
              <a href="./doc/app-release.apk" download>
                <img src="./img/apk.svg" alt="" />
              </a>
            </StoreBadge>
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ ...transitionSoft, delay: 0.12 }}
        >
          <motion.img
            className="h-[320px] w-auto object-contain drop-shadow-[0_30px_60px_rgba(0,0,0,0.18)] md:w-[430px] lg:w-[500px] xl:w-[821px]"
            src="./img/bannerMob.svg"
            alt=""
            animate={isMdUp ? { y: [0, -6, 0] } : { y: 0 }}
            transition={
              isMdUp
                ? {
                    duration: 5,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }
                : { duration: 0 }
            }
          />
        </motion.div>
      </div>
    </section>
  );
}

export default IcbMobile;
